import { FC } from "react";

import { cn } from "@/utils/tailwind";

import { VnBox } from "./VnBox";
import { VnProgress } from "./VnProgress";
import { TextVariantType } from "./VnText/variants";
import { VnText } from "./VnText/VnText";

type VnStepIndicatorPropsType = {
  currentStep: number;
  totalSteps: number;
  className?: string;
  titleVariant?: TextVariantType;
  titleClassName?: string;
};

export const VnStepIndicator: FC<VnStepIndicatorPropsType> = ({
  currentStep,
  totalSteps,
  className,
  titleVariant = "md",
  titleClassName,
}) => {
  const progressPercentage = (currentStep / totalSteps) * 100;

  return (
    <VnBox className={className}>
      <VnText
        variant={titleVariant}
        className={cn("text-muted-foreground mb-2", titleClassName)}
        i18nKey="common:stepIndicator"
        i18nOptions={{
          currentStep,
          totalSteps,
        }}
      />
      <VnProgress value={progressPercentage} />
    </VnBox>
  );
};
